<template>
    <div class="container">
        <div class="show-name" @click="handleDialogShow">
            <slot name="content">{{content}}</slot>
        </div>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%">
            <div class="content">
                <div class="msg">支持类型：视频课程、直播课程。防录屏跑马灯开启后，不管学员观看视频课程还是直播课程，都会在课程播放页面以跑马灯的形式展示自己的用户名和ID</div>
                <div class="box">
                    <div class="maker">
                        <div class="item">
                            <div class="item-name">版权声明</div>
                            <div class="item-content">
                                <el-radio v-model="copy_right" :label="1" @change="copyRight">开启</el-radio>
                                <el-radio v-model="copy_right" :label="0" @change="copyRight">关闭</el-radio>
                                <div class="t">开启后，在课程的顶部会出现版权提示</div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="item-name">跑马灯样式</div>
                            <div class="item-content">
                                <div class="f1">
                                    字体颜色
                                    <div class="color-list">
                                        <div class="color-list-item-box" v-for="(item, index) in colorList"
                                            :key="index">
                                            <div :class="['color-list-item', activeColor === item ? 'active' : '']"
                                                :style="{background: item}" @click="handleColor(item)">
                                                <i class="el-icon-check" v-if="activeColor === item"></i>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="f2">
                                    字体大小
                                    <div class="slider">
                                        <el-slider v-model="font_size" @change="fontSize"></el-slider>
                                    </div>
                                </div>
                                <div class="f2">
                                    透明度
                                    <div class="slider">
                                        <el-slider v-model="transparency" @change="opacity"></el-slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shower">
                        <div class="mask" v-if="isShowCopyRight">
                            <div class="text">【版权声明】本课程版权归提供者所有，仅限个人学习，严禁任何形式的录制、传播和账号分享。一经发现，平台将依法保留追究权，情节严重者将承担法律责任。
                            </div>
                        </div>
                        <div class="show"
                            :style="{fontSize: font_size + 'px', opacity: transparency / 100, color: activeColor}">
                            shower</div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleDialogClose">取消</el-button>
                <el-button type="primary" @click="handleDialogConfirm">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            copy_right: 1,
            isShowCopyRight: false,
            font_size: 26,
            transparency: 40,
            activeColor: '#0F5DFB',
            isActive: false,
            colorList: [
                '#333333',
                '#0F5DFB',
                '#1FA5FA',
                '#8278F1',
                '#08BB07',
                '#13BE82',
                '#FAD200',
                '#DCB978',
                '#FF9646',
                '#FA648D',
                '#FF2B2C',
                '#FFFFFF'
            ]
        };
    },
    props: {
        type: {
            type: String,
            default: 'primary'
        },
        content: {
            type: String,
            default: '点击设置'
        },
        dialogTitle: {
            type: String,
            default: '防录屏跑马灯'
        },
        opacityConfig: {}
    },
    computed: {},
    created() {
        this.copy_right = this.opacityConfig.copy_right;
        if (this.copy_right == 1) {
            this.isShowCopyRight = true;
        }
        this.font_size = this.opacityConfig.font_size || 20;
        this.activeColor = this.opacityConfig.color;
        this.transparency = this.opacityConfig.opacity;
    },
    methods: {
        copyRight(o) {
            if (o == 1) {
                this.isShowCopyRight = true;
            } else {
                this.isShowCopyRight = false;
            }
        },
        fontSize(o) {
            console.log(`o`, o);
            this.font_size = o;
        },
        opacity(o) {
            console.log(`o`, o);
            this.transparency = o;
        },
        handleColor(item) {
            this.activeColor = item;
        },
        handleDialogShow() {
            this.dialogVisible = true;
        },
        handleDialogClose() {
            this.dialogVisible = false;
        },
        handleDialogConfirm() {
            this.$emit('submit', {
                copy_right: this.copy_right,
                font_size: this.font_size,
                transparency: this.transparency,
                activeColor: this.activeColor
            });
            this.$message.success('保存成功');
            this.dialogVisible = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    .show-name {
        font-size: 12px;
        color: #1D517E;
        cursor: pointer;
    }
    .content {
        width: 100%;
        .msg {
            font-size: 14px;
            color: #999999;
        }
        .box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 30px;
            .maker {
                flex: 1;
                .item {
                    &:first-of-type {
                        margin-bottom: 40px;
                    }
                    width: 100%;
                    display: flex;
                    .item-name {
                        width: 100px;
                        font-size: 14px;
                        color: #34383e;
                    }
                    .item-content {
                        width: 100%;
                        box-sizing: border-box;
                        padding-right: 80px;
                        .t {
                            margin-top: 16px;
                            color: #666666;
                        }
                        .f1 {
                            color: #34383e;
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            .color-list {
                                width: 70%;
                                display: flex;
                                flex-wrap: wrap;
                                .color-list-item-box {
                                    width: 56px;
                                    margin-bottom: 20px;
                                    .color-list-item {
                                        width: 36px;
                                        height: 36px;
                                        opacity: 1;
                                        border-radius: 50%;
                                        cursor: pointer;
                                        &:last-child {
                                            border: 1px solid #f1f1f1;
                                            border-radius: 50%;
                                        }

                                        &.active {
                                            display: flex;
                                            justify-content: center;
                                            align-items: center;
                                            font-size: 20px;
                                            color: white;
                                        }
                                        &.black {
                                            color: black;
                                        }
                                    }
                                }
                            }
                        }
                        .f2 {
                            color: #34383e;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .slider {
                                width: 70%;
                            }
                        }
                    }
                }
            }
            .shower {
                flex: 1;
                background: #d8d8d8;
                position: relative;
                overflow: hidden;
                .show {
                    animation: run 5s linear infinite;
                    padding-top: 80px;
                    position: absolute;
                    white-space: nowrap;
                }
                .mask {
                    background-color: black;
                    opacity: 0.7;
                    margin-top: 20px;
                    height: 30px;
                    line-height: 30px;

                    .text {
                        animation: run2 10s linear infinite;
                        position: absolute;
                        white-space: nowrap;
                        color: white;
                        font-size: 12px;
                    }
                }
            }

            @keyframes run {
                0% {
                    left: 0;
                }
                100% {
                    left: 100%;
                }
            }
            @keyframes run2 {
                0% {
                    left: 100%;
                }
                100% {
                    left: -100%;
                }
            }
        }
    }
}
</style>